export const electionTypeArray = ["Parliament Seat", "Local Assembly"];